import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
//ACTIONS AND CONTEXT
import { RestActions } from "../../actions";
import { useMainContext } from "../../contexts/MainContext";
import { useCatalogsContext } from "../../contexts/CatalogsContext";
//COMPONENTS
import SearchEngineFiltersDemand from './SearchEngineFiltersDemand';
import SearchEngineListDemand from './SearchEngineListDemand';
import ButtonSettings from '../../components/atoms/ButtonSettings';
import ButtonProfile from '../../components/atoms/ButtonProfile';
import ButtonModalOneInputForm from '../../components/atoms/ButtonModalOneInputForm';
import ModalConfirmCloseSession from '../../components/atoms/ModalConfirmCloseSession';
//ASSETS
import './stylesDemand.css';
import logo from '../../assets/img/4SRealEstate_MultipleLines.png';
import newProject from '../../assets/icons/new-project.svg';
import admin from '../../assets/icons/icon-admin.svg';
import HeaderDemand from '../../components/atoms/headerDemand';


/**
    * Pagina Home
    * @component
*/
const HomeDemand = ({ preloadReady }) => {
    const rest = new RestActions();
    let mainContext = useMainContext();
    let catalogs = useCatalogsContext();

    const [dataTable, setDataTable] = useState({});
    const [pageLimit, setPageLimit] = useState(10);
    const [currentFilters, setCurrentFilters] = useState({});
    window.sessionStorage.removeItem('phaseID');

    useEffect(() => {
        if (preloadReady)
            findPhases(1);
    }, [preloadReady, currentFilters]);

    /**
        * Obtiene el catalogo de desarrolladores por medio de petición GET.
    */
    const onDeveloperAdded = async () => {
        catalogs.setDevelopers(await rest.get("getDevelopers"));
    }

    /**
        * Obtiene un listado de fases teneiendo en cuenta los filtros seleccioandos por el usuario
        * @param {number} _pageNumber - numero de pagina actual (por defecto 1)
        * 
    */
    const findPhases = async (_pageNumber) => {
        let onlyFavorites = (Object.keys(currentFilters).length) ? false : true;
        let params = Object.assign({}, currentFilters, { userID: mainContext.session.userID, onlyFavorites: onlyFavorites, pageLimit: pageLimit, pageNumber: _pageNumber })
        mainContext.setIsLoading(true);
        try {
            let response = await rest.post("findPhases", params);
            setDataTable(response);
            mainContext.setIsLoading(false);
        }
        catch (error) {/*TODO SOMETHING*/ }
    }

    return (
        (preloadReady) &&
        <section className="section-list">
            <HeaderDemand />
            <div className="container">
                <div className="row mt-5 mb-4 px-5">
                    <div className="col col-12">
                        <h1>BIENVENIDO A SIGII <br />
                            <hr className="home-hr" /></h1>
                    </div>
                </div>
                <div className="row px-md-5 mb-5">
                    <div className="col col-12">
                        <div className="custom-card">
                            <div className="custom-card-header p-3">
                                <h4>BUSCADOR DE INICIATIVAS</h4>
                                <Link to="/createDemand" className="colorBlack">
                                    <FontAwesomeIcon icon={faPlusCircle} size="2x" title='Nueva iniciativa'/>
                                </Link>
                            </div>
                            <div className="custom-card-body px-3">
                                <SearchEngineFiltersDemand handlerFilters={setCurrentFilters} />
                                <SearchEngineListDemand handleRefresh={findPhases} data={dataTable} />
                            </div>
                        </div>
                    </div>
                </div>
                <ModalConfirmCloseSession />
            </div>
        </section>
    )
}
export default HomeDemand;